import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Posao } from './posao';

@Component({
  selector: 'yt-posao-modal-update',
  templateUrl: './posao-modal-update.component.html'
})
export class PosaoModalUpdateComponent extends BaseModalUpdateComponent<Posao> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Posao>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
    
  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
